import Informacje from "./Informacje"

export default Informacje
